import script from "./CouponPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponPopup.vue?vue&type=script&setup=true&lang=js"

import "./CouponPopup.vue?vue&type=style&index=0&id=37977774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37977774"]])

export default __exports__